import VipContactListView from './VipContactListView';

export default VipContactListView;
